new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_header',
  data: {
    header: {
      useFirst: true, // first headerBar
      myaccount_options: 'dropdown', // 'none' = no dropdowns, 'dropdown' = hover and dropdown menu;
      isNavUp: true,
      isNavDown: true,
      isNavMin: false,
      lastScrollTop: 0,
      menuMobile: false,
      openCategorysMobile: false,
    },
    searchOpened: false,
    cartOpened: false,
  },
  methods: {
    addPaddingHeader() {
      const headerTransparent = document.querySelector('.nav-up');
      const header = document.querySelector('header[data-role="heading"]');
      const headerHeight = header.clientHeight;
      const mainTag = document.querySelector('main[role="main"]');
      const mainDiv = document.querySelector('.main-content');

      if (headerTransparent) {
        if (view_origin != "home") {
          if (mainTag) {
            mainTag.style.paddingTop = `${headerHeight}px`;
          } else {
            mainDiv.style.paddingTop = `${headerHeight}px`;
          }
        }
      } else {
        if (mainTag) {
          mainTag.style.paddingTop = `${headerHeight}px`;
        } else {
          mainDiv.style.paddingTop = `${headerHeight}px`;
        }
      }
    },
    runSpeechRecognition() {
      var isChromium = window.chrome;
      var winNav = window.navigator;
      var vendorName = winNav.vendor;
      var isOpera = typeof window.opr !== "undefined";
      var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
      var isIOSChrome = winNav.userAgent.match("CriOS");

      if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
        let output = document.querySelector(".output-search");
        let action = document.querySelector(".microphone");
        let inputMic = document.querySelector(".search__text");

        var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;

        var recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.lang = 'pt-BR';


        recognition.onstart = function () {
          if (!output.classList.contains("hide")) {
            output.classList.toggle("hide");
          }

          action.classList.toggle('active');
        };

        recognition.onspeechend = function () {

          action.classList.toggle('active');
          recognition.stop();
        }

        recognition.onresult = function (event) {
          var transcript = event.results[0][0].transcript;
          var confidence = event.results[0][0].confidence * 100;

          if (confidence < 50) {
            inputMic.classList.toggle('not-understand')
            output.classList.toggle("hide");
            inputMic.value = "Desculpe não entendi muito bem.";
          } else {
            inputMic.value = transcript
            document.querySelector('.search__submit').click()
          };

        };

        // start recognition
        recognition.start();
      } else return document.querySelector(".microphone-search").remove();
    },
    scrollFixedMenu() {
      const menuFixed = document.querySelector('.menu-fixed');
      if (menuFixed) {
        let lastScrollTop = 0;
        menuFixed.classList.remove('active');

        window.addEventListener('scroll', function () {
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > lastScrollTop) {
            // Scrolling down
            menuFixed.classList.add('active');
          } else {
            // Scrolling up
            menuFixed.classList.remove('active');
          }

          lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For mobile or negative scrolling
        });
      }
    },
    handleScroll() {
      const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const scrollDifference = st - this.lastScrollTop;
      const customMobile = document.getElementById('custom-mobile-nav');
      const headerThird = document.getElementById('header-third');
      const quickMenu = document.getElementById('quick-menu-id');
      const whatsappWidget = document.getElementById('widget-whatsapp');

      if (st > this.lastScrollTop)
        this.header.isNavUp = false;
      else {
        if (st === 0)
          this.header.isNavUp = true;
      }

      if (st >= 90 && scrollDifference > 0) {
        this.header.isNavDown = false;
        this.header.isNavMin = true;

        if (customMobile)
          customMobile.classList.add('hide');

        if (headerThird)
          headerThird.classList.add('hide');

        if (quickMenu) {
          quickMenu.classList.add('hide');
          whatsappWidget.style.bottom = '';
        }

      } else {
        this.header.isNavDown = true;
        this.header.isNavMin = false;
        this.header.isNavMenuHide = false;

        if (customMobile)
          customMobile.classList.remove('hide');

        if (headerThird)
          headerThird.classList.remove('hide');

        if (quickMenu) {
          quickMenu.classList.remove('hide');
          whatsappWidget.style.bottom = '79px';
        }
      }

      this.lastScrollTop = st;
    },
    filterItems(item1, item2, item3, item4) {
      var data = [item1, item2, item3, item4];

      for (var i = 0; i < data.length; i++) {
        var element = document.querySelector('[item="' + data[i] + '"]');
        switch (data[i]) {
          case "home":
            element.setAttribute('href', '/');
            break;
          case "menu":
            var newSpan = document.createElement('span');
            newSpan.setAttribute('class', 'quick-menu__item--link toggleMenu js-mobile-nav-trigger');

            while (element.firstChild) {
              newSpan.appendChild(element.firstChild);
            }

            element.parentNode.replaceChild(newSpan, element);
            break;
          case "cart":
            element.setAttribute('href', '/carrinho');
            break;
          case "user":
            element.setAttribute('href', '/clientes/identificacao/?next=/clientes/minha-conta/');
            break;
          case "wishlist":
            element.setAttribute('href', '/clientes/minha-conta/minha-lista-de-produtos/');
            break;
        }
      }
    }
  },
  mounted() {
    $('.contact-header').slick({
      arrows: true,
      infinite: false,
      autoplay: false,
      mobileFirst: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 100,
      responsive: [
        {
            breakpoint: 991,
            settings: 'unslick'
        },
      ]
    });

    waitForElementToExist('#faixa-cupom').then(element => {
      const faixCupom = document.querySelector('.faixa-cupom');
      if (faixCupom) {
          const formButton = document.querySelector('.faixa-cupom-form button');
          const spanElement = document.getElementById("valorParaCopiar");

          if (spanElement) {
              if (formButton) {
                  formButton.addEventListener("click", (e) => {
                      e.preventDefault();

                      const range = document.createRange();
                      range.selectNodeContents(spanElement);

                      const selection = window.getSelection();
                      selection.removeAllRanges();
                      selection.addRange(range);

                      try {
                          const copied = document.execCommand("copy");
                          selection.removeAllRanges();

                          if (copied) {
                              alert("Valor copiado: " + spanElement.textContent);
                          } else {
                              alert("Não foi possível copiar o texto.");
                          }
                      } catch (err) {
                          console.error("Erro ao copiar: ", err);
                          alert("Erro ao copiar o texto.");
                      }
                  });
              }
          }
      }
    });

    const stopwatchElement = document.querySelector('.stopwatch');
    if (stopwatchElement) {
      const urlParametro = stopwatchElement.getAttribute('data-url') ? stopwatchElement.getAttribute('data-url').trim() : "";
      const hora = parseInt(stopwatchElement.getAttribute('data-hour'));
      const dia = parseInt(stopwatchElement.getAttribute('data-day'));
      const mes = parseInt(stopwatchElement.getAttribute('data-month'));
      const ano = parseInt(stopwatchElement.getAttribute('data-year'));
  
      // Verifique se os atributos necessários estão definidos e não são NaN
      if (!isNaN(hora) && !isNaN(dia) && !isNaN(mes) && !isNaN(ano)) {
        const urlAtual = window.location.pathname;
        let dataTermino;
        let cronometro;
  
        function atualizarCronometro() {
          const agora = new Date().getTime();
          const termino = dataTermino.getTime();
          const tempoRestante = termino - agora;
  
          if (tempoRestante >= 0) {
            const dias = Math.floor(tempoRestante / (1000 * 60 * 60 * 24));
            const horas = Math.floor((tempoRestante % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutos = Math.floor((tempoRestante % (1000 * 60 * 60)) / (1000 * 60));
            const segundos = Math.floor((tempoRestante % (1000 * 60)) / 1000);

            function formatarDigitos(numero) {
                // Formata o número com dois dígitos (exemplo: "08", "12")
                const numeroFormatado = numero.toString().padStart(2, '0');
                
                // Divide os dígitos e envolve cada um em uma tag <span>
                return `<span>${numeroFormatado[0]}</span><span>${numeroFormatado[1]}</span>`;
            }

            const diasFormatado = formatarDigitos(dias);
            const horasFormatado = formatarDigitos(horas);
            const minutosFormatado = formatarDigitos(minutos);
            const segundosFormatado = formatarDigitos(segundos);
  
            document.getElementById("cronometro").innerHTML =`<p>Termina em </p> <div>${diasFormatado}d ${horasFormatado}h ${minutosFormatado}m ${segundosFormatado}s</div>`;
          } else {
            document.getElementById("cronometro").innerHTML = "Tempo esgotado!";
            clearInterval(cronometro);
          }
        }
  
        function mostrarCronometro() {
          dataTermino = new Date(ano, mes - 1, dia, hora, 0);
          cronometro = setInterval(atualizarCronometro, 1000);
        }
  
        // Mostrar cronômetro em todas as páginas se urlParametro estiver vazio
        if (urlParametro === "" || urlAtual.includes(urlParametro)) {
          mostrarCronometro();
        } else {
          stopwatchElement.style.display = 'none';
        }
      } else {
        console.error('Os atributos data-hour, data-day, data-month ou data-year estão ausentes ou inválidos.');
      }
    }

    this.addPaddingHeader();
    this.scrollFixedMenu();

    window.addEventListener('scroll', this.handleScroll);

    let item1, item2, item3, item4

    if (document.getElementById('quick-item-1')) {
      item1 = document.getElementById('quick-item-1').getAttribute('item');
    }
    if (document.getElementById('quick-item-2')) {
      item2 = document.getElementById('quick-item-2').getAttribute('item');
    }
    if (document.getElementById('quick-item-3')) {
      item3 = document.getElementById('quick-item-3').getAttribute('item');
    }
    if (document.getElementById('quick-item-4')) {
      item4 = document.getElementById('quick-item-4').getAttribute('item');
    }

    if (item1 && item2 && item3 && item4) {
      this.filterItems(item1, item2, item3, item4);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    cartOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },

    searchOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
  }
});

const openSearch = document.querySelector('.open-search');
  const openSearchIcon = document.querySelector('.open-search__icon');
  const search = document.querySelector('.search');
  if(openSearch) {
    openSearchIcon.addEventListener('click', () => {
      search.classList.toggle('active');
      openSearch.classList.toggle('active');
    });
  }

/* Mobile Wrapper */
const mobileNavLinks = document.querySelectorAll('.mobile-nav__link.ewrap');

mobileNavLinks.forEach(link => {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    this.classList.toggle('active');
    const wrapper = this.nextElementSibling;
    if (wrapper && wrapper.tagName === 'UL') {
      wrapper.classList.toggle('active');
    }
  });
});



// Ajusta a altura de .category-second com base nos .third-category + 50px
function adjustSecondCategoryHeight() {
  const mainMenu = document.querySelector('.main-menu');
  if (!mainMenu) return;

  const wrapLis = mainMenu.querySelectorAll('li.wrap-li');
  wrapLis.forEach((wrapLi) => {
    const secondCategory = wrapLi.querySelector('.category-second');
    if (!secondCategory) return;

    // Reset para medir altura natural
    secondCategory.style.height = '';

    const thirdLists = wrapLi.querySelectorAll('.third-category ul');
    if (!thirdLists.length) return;

    let maxThirdHeight = 0;
    thirdLists.forEach((ul) => {
      // Conta apenas filhos diretos li
      const liCount = Array.from(ul.children).reduce((acc, child) => acc + (child.tagName === 'LI' ? 1 : 0), 0);
      const ulHeight = liCount * 48; // cada li tem 48px
      if (ulHeight > maxThirdHeight) maxThirdHeight = ulHeight;
    });

    const targetHeight = maxThirdHeight + 50; // px extra

    // Pega a altura de todos os .second-category dentro do wrapLi
    const allSecondCategories = wrapLi.querySelectorAll('.second-category');
    let maxSecondHeight = 0;
    allSecondCategories.forEach((secondCat) => {
      const height = secondCat.offsetHeight;
      maxSecondHeight += height;
    });

    // Usa a maior altura entre targetHeight e maxSecondHeight
    const finalHeight = Math.max(targetHeight, maxSecondHeight);
    const secondHeight = secondCategory.offsetHeight;
    if (finalHeight > secondHeight) {
      secondCategory.style.height = finalHeight + 'px';
    }
  });
}

// Executa no load inicial (com atraso) e em mudanças de viewport
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { setTimeout(adjustSecondCategoryHeight, 1500); });
} else {
  setTimeout(adjustSecondCategoryHeight, 1500);
}
window.addEventListener('load', function() { setTimeout(adjustSecondCategoryHeight, 1500); });
window.addEventListener('resize', adjustSecondCategoryHeight);

$('#js-texto-header').slick({
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2500,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 1000,
});